export default __webpack_public_path__ + "images/30def56e78c121bc0a430b663e7e8301.svg";